import fvObject from "../fvObject";
import Vue from 'vue';
import fvLineCompute from "./fvLineCompute";
export default class fvSubassembly extends fvObject {
    constructor(sContent, parent, system) {
        super(sContent);
        this.isAnimation = false;
        this.originalSizes = {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            borderWidth: this.borderWidth
        }
        this.x += this.x * this.frameScaleX;
        this.y += this.y * this.frameScaleY;
        this.height += this.height * this.frameScaleY;
        this.width += this.width * this.frameScaleX;
        //标示未基本图元
        this.type = "basic";
        //父对象指针
        this.parent = parent;
        //注册名称
        this.name = this.registerName;
        //添加同canvas一样的对象system
        this._this = this.fvScript.system;
        //窗口大小
        this.windowSize = this.parent.windowSize;
        //图元原始（组态）大小
        this.originalSize = {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            borderWidth: this.borderWidth
        }
        //fvLineCompute类线性方法
        this.angleToPoints = fvLineCompute.angleToPoints;
        this.merge4 = fvLineCompute.merge4;
        //fvLineCompute类径向方法
        this.fcAddColorStop = fvLineCompute.fcAddColorStop;
        this.centerpoints = fvLineCompute.centerpoints;
        //syste对象保存
        this.system = system;
        //计算缩放比例
        this.zoom();
        //初始化各种状态
        this.initState();
        //初始化各渲染信息
        this.initRender();
        //初始化动画
        this.initAnimation();
        //初始化各种状态
        this.definePropertyEx();
        // 位移属性
        this.translateX = 0;
        this.translateY = 0;
        // 旋转属性
        this.rotating = 0;
        // 旋转中心点
        this.originPinitX = 0;
        this.originPinitY = 0;
    }
    /**
     * 选择线性
     * 参数: lineType和dom对象
     */
    // 选择线型
    chooseRenderType(lineType, domObj) {
        // 添加虚线属性
        let dashed1 = [20, 10];
        let dashed2 = [5, 5];
        let dashed3 = [20, 6, 6, 6];
        let dashed4 = [20, 6, 6, 6, 6, 6];
        switch (lineType) {
            case 1:
                domObj.setAttribute('stroke-dasharray', dashed1)
                break;
            case 2:
                domObj.setAttribute('stroke-dasharray', dashed2)
                break;
            case 3:
                domObj.setAttribute('stroke-dasharray', dashed3)
                break;
            case 4:
                domObj.setAttribute('stroke-dasharray', dashed4)
                break;
            default:
                domObj.removeAttribute('stroke-dasharray')
                break;
        };
    }
    /**
     * 边线填充风格管道
     */
        //绘制管道
    drawStereo(svgRect,svgDom) {
        var byR0, byG0, byB0;
        var nR1, nG1, nB1;
        var Color = [];
        var rgbArr = [];
        rgbArr = this.borderColor.colorRgb();
        if (rgbArr.length != 3) {
            byR0 = 0;
            byG0 = 0;
            byB0 = 255;
        } else {
            byR0 = rgbArr[0];
            byG0 = rgbArr[1];
            byB0 = rgbArr[2];
        }
        Color = this.lineTypeStyle.stereoColor.colorRgb();
        nR1 = Color[0];
        nG1 = Color[1];
        nB1 = Color[2];
        var fAddR, fAddG, fAddB;
        var w = Math.max(1, parseInt(this.borderWidth));
        fAddR = (nR1 - byR0) / w;
        fAddG = (nG1 - byG0) / w;
        fAddB = (nB1 - byB0) / w;

        var faddx, faddy;
        var parm = {};
        parm.faddx = faddx;
        parm.faddy = faddy;
        parm.faddx = 0; parm.faddy = 0.0;

        faddx = parm.faddx;
        faddy = parm.faddy;
        var i = 0;
        var fWidthAdd;
        if (parseInt(this.borderWidth) <= 8)
            fWidthAdd = 2.0;
        else
            fWidthAdd = 2.0 * parseInt(this.borderWidth) / 32.0 + 2.0;

        i = -999;
        for (var fj = 1.0; fj <= parseInt(this.borderWidth); fj += fWidthAdd) {
            if ((i == Math.ceil(fj)) || (i + 1 == Math.ceil(fj)))
                continue;
            i = Math.ceil(fj);//这三行代码保证只有在线宽差距较大时才画，提高了效率

            var colorStyle = "rgb(";
            var tempr = byR0 + fAddR * i > 255 ? 255 : byR0 + fAddR * i;
            var tempg = byG0 + fAddG * i > 255 ? 255 : byG0 + fAddG * i;
            var tempb = byB0 + fAddB * i > 255 ? 255 : byB0 + fAddB * i;
            colorStyle += Math.ceil(tempr) + "," + Math.ceil(tempg) + "," + Math.ceil(tempb) + ")";
            let strokeStyle = colorStyle;
            let width = parseInt(this.borderWidth) + 1 - i;
            let roundA;
            if(this.fctype=="fvCakeObj"){
                svgRect.innerHTML += ` <path d="${svgDom.getAttribute("d")}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}" />`;
            }else if(this.fctype=="fvChipObj"){
                svgRect.innerHTML += ` <path d="${svgDom.getAttribute("d")}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}" />`;
            }else if(this.fctype=="fvRectObj"){
                let cx=this.cx - this.parent.parentX;
                let cy=this.cy - this.parent.parentY;
                let rWidth=parseFloat(svgDom.style.width);
                let rHeight=parseFloat(svgDom.style.height);
                //是否圆角
                if (this.round) {
                    let rx=parseFloat(svgDom.getAttribute("rx"));
                    let ry=parseFloat(svgDom.getAttribute("ry"));
                    roundA=this.getRectPath(cx, cy,rWidth,rHeight,rx,ry);
                } else {
                    roundA=this.getRectPath(cx, cy,rWidth,rHeight,0,0);
                }
                svgRect.innerHTML += ` <path d="${roundA}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}" />`;
            }else if(this.fctype=="fvEllipseObj"){
                let cx=parseFloat(svgDom.getAttribute("cx"));
                let cy=parseFloat(svgDom.getAttribute("cy"))
                let rx=parseFloat(svgDom.getAttribute("rx"));
                let ry=parseFloat(svgDom.getAttribute("ry"));
                roundA=this.getEllipsePath(cx, cy,rx,ry);
                svgRect.innerHTML += ` <path d="${roundA}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}" />`;
            }else if(this.fctype=="fvPolygonObj"){
                roundA=this.getpolygonPath(this.points);
                svgRect.innerHTML += ` <path d="${roundA}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}"/>`;
            }else if(this.fctype=="fvPolylineObj"){
                roundA=this.getPolylinePath(this.points);
                svgRect.innerHTML += ` <path d="${roundA}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}"/>`;
            }else if(this.fctype=="fvLineObj"){
                let cx=parseFloat(svgDom.getAttribute("x1"));
                let cy=parseFloat(svgDom.getAttribute("y1"));
                let rx=parseFloat(svgDom.getAttribute("x2"));
                let ry=parseFloat(svgDom.getAttribute("y2"));
                roundA=this.getLinePath(cx, cy,rx,ry);
                svgRect.innerHTML += ` <path d="${roundA}" stroke-dasharray="${svgDom.getAttribute("stroke-dasharray")}" stroke="${strokeStyle}" fill="none" stroke-width="${width}" stroke-linecap="${svgDom.getAttribute("stroke-linecap")}"/>`;
            }
        }
    }
    /*
        功能:初始化各种状态标记
        参数:无
        返回值:无
    */
    initState() {
        // 子类中使用
        this.isDelayedWaiting = false;
        //鼠标状态
        this.mouseState = 0;
        //选中状态
        this.selectState = 0;
        //有鼠标动作时,左键按下,右键按下状态
        this.lockState = 0;
        //是否禁止状态
        this.disableFlag = 0;
        //组件的显隐状态
        this.fcHide = this.fcHide || true;
        //禁用状态
        this.isEnable = this.isEnable || true;
        // 脚本控制组件显隐,权限高于动画
        this.fvScriptHide = this.fvScriptHide || true;
        //是否是放大状态
        this.isZoom = false;
        //是否是子对象
        this.isSub = false;
        //缓存是否需要更新
        this.isUpdataCache = true;
    }
    /*
        功能:初始化渲染模式
        参数:无
        返回值:无
    */
    initRender() {
        this.render = null;
        switch (this.renderType) {
            case 1:
                this.render = new Vue.prototype.fvRenderMove(this.renderConfig,this);
                break;
            case 2:
                this.render = new Vue.prototype.fvRenderContract(this.renderConfig);
                break;
            case 3:
                this.render = new Vue.prototype.fvRenderGrid(this.renderConfig);
                break;
            case 4:
                this.render = new Vue.prototype.fvRenderLine(this.renderConfig);
                break;
            case 5:
                this.render = new Vue.prototype.fvRenderPath(this.renderConfig);
                break;
            case 6:
                this.isDelayedWaiting = true;
                this.render = new Vue.prototype.fvRenderTexture(this.renderConfig, this._this, this.delayedWaiting.bind(this));
                break;
            default:
                break;
        }
    }
    /**
     * 唯一标识id
     */
    uuid() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;    // d是随机种子
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }
    /*
        功能:初始创建动画执行对象
        参数:无
        返回值:无
    */
    initAnimation() {
        //周期执行动画对象
        this.preAnimation = {};
        //缓存绘制后动画对象
        this.posAnimation = {};
        //鼠标动画对象
        this.mouseAnimationList = {};
        //绘制前执行动画对象
        this.preAnimationList = {};
        for (var property in this.animation) {
            //是否具有动画
            this.isAnimation = true;
            property = property + "Svg";
            var ani = new Vue.prototype[property](this);
            switch (ani.type) {
                case "fvContextMenu":
                case "fvMessage":
                case "fvVarInput":
                case "fvBoolInput":
                case "fvStringInput":
                case "fvVerticalDrag":
                case "fvHorDrag":
                case "fvLmousescript":
                case "fvRmousescript":
                case "fvMousescript":
                case "fvWindowOpen":
                    this.mouseAnimationList[ani.type] = ani;
                    break;
                case "fvFlow":
                case "fvHorFill":
                case "fvRotateMove":
                case "fvVerticalFill":
                    this.preAnimationList[ani.type] = ani;
                    // this.posAnimation[ani.type] = ani;
                    break;
                case "fvHide":
                case "fvForbid":
                case "fvVerticalMove":
                case "fvHorMove":
                    this.preAnimation[ani.type] = ani;
                    break;
                default:
                    this.preAnimationList[ani.type] = ani;
                    break
            }
        }
    }
    /**
     * svg线性渐变添加颜色
     */
    fclinearAddColorStop(id, config, i) {
        let beginColor = config.color[1].colorRgb();
        let endColor = config.color[0].colorRgb();
        if (config.spot && config.spot.length != 0) {
            for (var j = 0; j < config.spot.length; j++) {
                let aLi = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                aLi.setAttribute("offset", (i + parseFloat(config.spot[j])) / config.cycletimes);
                aLi.setAttribute("stop-color", config.color[j]);
                aLi.setAttribute("fill-opacity", config.transparent[j] / 255);
                document.getElementById(id).appendChild(aLi);
            }
        } else {
            let aLi = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
            document.getElementById(id).innerHTML += `<stop offset="0" stop-color="rgb(${endColor})" fill-opacity="${config.transparent[0] / 255}"></stop>`
            aLi.setAttribute("offset", parseFloat((i + config.symmetric)) / parseFloat(config.cycletimes));
            aLi.setAttribute("stop-color", "rgb(" + beginColor + ")");
            aLi.setAttribute("fill-opacity", config.transparent[1] / 255);
            document.getElementById(id).appendChild(aLi);
            if (config.symmetric < 1) {
                let str = `<stop offset="${(i + 1) / config.cycletimes}" stop-color="rgb(${endColor})" fill-opacity="${config.transparent[0] / 255}"></stop>`
                document.getElementById(id).innerHTML += str;
            }

        }
    }
    fcGetStartEndPt(startPt, endPt, inputRect, inputAng, x, y) {
        if(inputRect.style.width=="" ||inputRect.style.height==""){
            return;
        }
        startPt.x = parseFloat(x);
        startPt.y = parseFloat(y);
        let centerPt = {
            x: parseInt(parseFloat(x) + parseFloat(inputRect.style.width) / 2),
            y: parseInt(parseFloat(y) + parseFloat(inputRect.style.height) / 2)
        }

        let tempAng1 = inputAng;
        while (tempAng1 > (FC_PI / 2) || tempAng1 < 0) {
            if (tempAng1 > FC_PI / 2) {
                tempAng1 = Math.abs(tempAng1 - FC_PI);
            } else {
                tempAng1 = tempAng1 + FC_PI;
            }
        }

        let tempAng2 = Math.atan(parseFloat(inputRect.style.height) / parseFloat(inputRect.style.width));

        let tempAng3 = Math.abs(tempAng1 - tempAng2);

        let radius = parseInt(Math.sqrt(parseFloat(inputRect.style.width) * parseFloat(inputRect.style.width) + parseFloat(inputRect.style.height) * parseFloat(inputRect.style.height)) * Math.cos(tempAng3) / 2);
        let colorChangeAng = inputAng;//计算渐变方向
        colorChangeAng = this.fcAdjustAng(colorChangeAng);//角度调整到 0到2*FC_PI

        startPt.x = -radius * Math.cos(colorChangeAng) + centerPt.x;
        startPt.y = -radius * Math.sin(colorChangeAng) + centerPt.y;

        endPt.x = radius * Math.cos(colorChangeAng) + centerPt.x;
        endPt.y = radius * Math.sin(colorChangeAng) + centerPt.y;
    }

    fcAdjustAng(ang) {
        while (ang > 2 * FC_PI) {
            ang = ang - 2 * FC_PI;
        }
        while (ang < 0) {
            ang = ang + 2 * FC_PI;
        }
        return ang;
    }
    /**
    * svg线性渐变渲染
    */
    linearGradient(id, config, svg, x, y,defs) {
        //计算渐变起始终止点
        if(config.rotate1!==undefined){
            let startPt = {
                x: 0,
                y: 0,
                r: 0
            };
            let endPt = {
                x: 0,
                y: 0,
                r: 0
            };


            this.fcGetStartEndPt(startPt, endPt, svg, config.rotate1 * FC_PI / 180, x, y);
            let str = `<linearGradient id="${id}" gradientUnits="userSpaceOnUse" x1="${startPt.x}" y1="${startPt.y}" x2="${endPt.x}" y2="${endPt.y}"></linearGradient>`;
            defs.innerHTML = str;
            for (var i = 0; i < config.cycletimes; i++) {
                this.fclinearAddColorStop(id, config, i);
            }
            svg.style.fill = `url(#${id})`;
        }
    }
    /**
     * svg径向渐变渲染
     */
    radialGradient(id, config, svg, x, y,defs1) {
        let startPt = { x: 0, y: 0, r: 0 }
        let endPt = { x: 0, y: 0, r: 0 }
        this.fcGetStartEndPathPt(startPt, endPt, svg, config, x, y);
        // let defs1 = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        let lx = endPt.x - startPt.x;
        let ly = endPt.y - startPt.y;
        let str1 = `<radialGradient id="${id}" cx="${endPt.x - lx}" cy="${endPt.y - ly}" r="${endPt.r}" fx="${startPt.x - lx}" fy="${startPt.y - ly}" fr="${startPt.r}" gradientUnits="userSpaceOnUse"></radialGradient>`;
        defs1.innerHTML = str1;
        // this.system.insertBefore(defs1, svg);
        for (var h = 1; h <= config.cycletimes; h++) {
            this.fcAddColorStop(id, config, h);
        }
        svg.style.fill = `url(#${id})`;
    }
    //svg径向渐变计算开始坐标，结束坐标
    fcGetStartEndPathPt(startPt, endPt, inputRect, config, x, y) {
        let centerPt = {
            x: parseInt(parseFloat(x) + parseFloat(inputRect.style.width) / 2),
            y: parseInt(parseFloat(y) + parseFloat(inputRect.style.height) / 2)
        }
        startPt.x = centerPt.x;
        startPt.y = centerPt.y;
        startPt.r = 0;
        endPt.x = centerPt.x;
        endPt.y = centerPt.y;
        endPt.r = Math.sqrt(parseFloat(inputRect.style.width) * parseFloat(inputRect.style.width) + parseFloat(inputRect.style.height) * parseFloat(inputRect.style.height)) / 2;
        this.centerpoints(inputRect, config, startPt, endPt);
    }
    /***
     * svg纹理渐变
     */
    pattern(id, svg,def) {
        // let def = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        let str2 = `<pattern id="${id}" width="100%" height="100%" x="0" y="0" patternContentUnits="userSpaceOnUse"></pattern>`;
        def.innerHTML = str2;
        // this.system.insertBefore(def, svg);
        this.render.rend(this.system, svg, id);
        svg.style.fill = `url(#${id})`;
    }
    /*
        功能:定义监听属性，用于脚本中对图元属性赋值的监听
        参数:无
        返回值:无
    */
    definePropertyEx() {

        Object.defineProperty(this, "X", {
            set: function (value) {
                if (this.fctype == "fvButtonObj") {
                    this.x = value;
                    this.setText();
                }
                this.cx = value;
                this.setPosition();
                this.isUpdataCache = true;
            },
            get: function () {
                return this.x;
            }
        })
        Object.defineProperty(this, "Y", {
            set: function (value) {
                if (this.fctype == "fvButtonObj") {
                    this.y = value;
                    this.setText();
                }
                this.cy = value;
                this.setPosition();
                this.isUpdataCache = true;
            },
            get: function () {
                return this.y;
            }
        })
        Object.defineProperty(this, "Width", {
            set: function (value) {
                this.width = value;
                this.setPosition();
                this.isUpdataCache = true;
            },
            get: function () {
                return this.width;
            }
        })
        // Object.defineProperty(this, "Border", {
        //     set: function (value) {
        //         if (this.fctype !== "fvPictureObj") return;
        //         if (value == 0) {
        //             this.isBorder = 0;
        //         } else {
        //             this.isBorder = value;
        //         }
        //         this.createBorder();
        //         this.isUpdataCache = true;
        //     },
        //     get: function () {
        //         return this.isBorder;
        //     }
        // });
        Object.defineProperty(this, "Height", {
            set: function (value) {
                this.height = value;
                this.setPosition();
                this.isUpdataCache = true;
            },
            get: function () {
                return this.height;
            }
        })
        Object.defineProperty(this, "LColor", {
            set: function (value) {
                if (this.fctype == "fvLineObj" || this.fctype == "fvPolylineObj") return;
                if (value >= 0 && value < 2048) {
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    this.borderColor = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    this.isUpdataCache = true;
                } else {
                    console.warn("颜色索引不存在");
                }
                this.setBorderColor();
                this.isUpdataCache = true;
            },
            get: function () {
                return this.borderColor;
            }
        })
        Object.defineProperty(this, "Text", {
            set: function (value) {
                this.innerText = value;
                this.setText();
                this.isUpdataCache = true;
            },
            get: function () {
                return this.innerText;
            }
        })
        Object.defineProperty(this, "FColor", {
            set: function (value) {
                function zero_fill_hex(num, digits) {
                    var s = num.toString(16);
                    while (s.length < digits)
                        s = "0" + s;
                    return s;
                }
                function rgb2hex(rgb) {
                    if (rgb.charAt(0) == '#')
                        return rgb;
                    var ds = rgb.split(/\D+/);
                    var decimal = Number(ds[1]) * 65536 + Number(ds[2]) * 256 + Number(ds[3]);
                    return "#" + zero_fill_hex(decimal, 6);
                }
                if (value >= 0 && value < 2048) {
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    if (this.fctype == 'fvLineObj' || this.fctype == 'fvPolylineObj' || this.fctype == 'fvButtonObj') {
                        this.borderColor = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    } else {
                        this.color = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    }
                    if (this.renderType !== 0) {
                        if (this.renderConfig.color) {
                            this.renderConfig.color[0] = rgb2hex(this.color);
                        }
                    }
                    this.setFillColor();
                    this.isUpdataCache = true;
                } else {
                    console.warn("颜色索引不存在");
                }
            },
            get: function () {
                return this.color;
            }
        })
    }
    /*
        功能:根据缩放比例缩放图元大小
        参数:无
        返回值:无
    */
    zoom() {
        this.magnification = this.parent.getMagnification();
        this.x = (this.originalSize.x * this.magnification.x);
        this.y = (this.originalSize.y * this.magnification.y);
        this.width = (this.originalSize.width * this.magnification.x);
        this.height = (this.originalSize.height * this.magnification.y);
        this.borderWidth = (this.originalSize.borderWidth * this.magnification.x);
    }
    theEvent(div, sContent) {
        div.style.cursor = "pointer";
        //鼠标按下
        div.onmousedown = function (e) {
            this.onMouseDownSvg(e, div);
            if (sContent.fctype == "fvButtonObj") {
                div.firstElementChild.nextSibling.style.fill = this.borderColor;
                div.firstElementChild.nextSibling.style.stroke = "#57a3f3";
            }
        }.bind(this);
        //鼠标抬起
        div.onmouseup = function (e) {
            this.onMouseUpSvg(e);
            if (sContent.fctype == "fvButtonObj") {
                div.firstElementChild.nextSibling.style.fill =this.borderColor;
                div.firstElementChild.nextSibling.setAttribute("filter",`url(#${this.registerName})`);
                div.firstElementChild.nextSibling.style.stroke ="rgba(255,255,255,.6)";
            }
        }.bind(this);
        //鼠标移入
        div.onmouseenter = function (e) {
            this.onMouseEnterSvg(e);
            if (sContent.fctype == "fvButtonObj") {
                div.firstElementChild.nextSibling.style.fill =this.borderColor;
                div.firstElementChild.nextSibling.style.stroke = "#57a3f3";
            }
        }.bind(this);
        //鼠标移出
        div.onmouseleave = function (e) {
            this.onMouseLeaveSvg(e);
            if (sContent.fctype == "fvButtonObj") {
                div.firstElementChild.nextSibling.style.fill = this.borderColor;
                div.firstElementChild.nextSibling.setAttribute("filter",`url(#${this.registerName})`);
                div.firstElementChild.nextSibling.style.stroke ="rgba(255,255,255,.6)";
            }
        }.bind(this);
        //鼠标移动
        div.onmousemove = function (e) {
            this.onMouseMoveSvg(e, div);
        }.bind(this);
    }
    /*
        功能:图元所有信息初始化完成后调用
        参数:无
        返回值:无
    */
    createSucss(dom, sContent) {
        if (this.isSub) {
            this.parent.updataSize({
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height,
                borderWidth: parseFloat(this.borderWidth),
                obj: this
            });
        }
        if(sContent.animation.fvLmousescript ||sContent.animation.rmousedownscript||sContent.animation.fvContextMenu|| sContent.animation.fvMessage||sContent.animation.fvMousescript||sContent.animation.fvVerticalDrag||sContent.animation.fvHorDrag|| sContent.fctype == "fvButtonObj"){
            this.theEvent(dom, sContent);
        }
    }

    /*
        功能:
        参数:无
        返回值:无
    */
    delayedWaiting() {
        if (typeof this.complete == "function") {
            this.complete(this);
        }
    }
    /*
        功能:图形绘制前执行
        参数:无
        返回值:无
    */
    executePreAnimation(canvas,value) {
        this.canvas = canvas;
        // 打组禁止
        if (this.disableFlag) {
            return;
        }
        // 当前图元禁止
        if (!this.fcHide) {
            for (const property in this.animation) {
                if (new Vue.prototype[property](this).type == "fvTwinkel") {
                    for (let a in this.preAnimationList) {
                        this.preAnimationList[a].run(this.canvas, this.isEnable);
                    }
                } else {
                    return
                }
            }
        }
        if (canvas) {
            for (let p in this.preAnimationList) {
                this.preAnimationList[p].run(canvas, this.isEnable,value)
            }
        }
    }
    /*
        功能:图形绘制后执行
        参数:无
        返回值:无
    */
    // executePosAnimation(canvas){
    //     // 打组禁止
    //     if(this.disableFlag){
    //         return;
    //     }
    //     // 当前图元禁止
    //     if(!this.fcHide){
    //         return;
    //     }
    //     for(var p in this.posAnimation){
    //         if(typeof this.posAnimation[p].runEnd == "function"){
    //             this.posAnimation[p].runEnd(canvas);
    //         }
    //     }
    // }
    /*
        功能:创建
        参数:无
        返回值:无
    */
    create() {
        this.init();
    }
    /*
        功能:缓存函数，需要被子类重写
        参数:无
        返回值:无
    */
    cache(canvas) {
        return false;
    }
    /*
        功能:判断图元是否包含动画
        参数:type动图类型，或类型数组
        返回值:无
    */
    isHasAnimation(type) {
        if (typeof type == "string") {
            if (this.mouseAnimationList[type])
                return true;
            else
                return false;
        } else if (typeof type == "object" && type.length >= 0) {
            for (var p in this.mouseAnimationList) {
                for (var i = 0; i < type.length; i++) {
                    if (p == type[i]) {
                        return true;
                    }
                }
            }
            return false
        } else {
            for (var p in this.animation) {
                return true;
            }
            return false;
        }
    }
    /*
        功能:设置图元渲染模式
        参数:无
        返回值:无
    */
    Render(canvas) {
        if (this.render) {
            var rect = {
                left: this.cx,
                top: this.cy,
                bottom: parseFloat(this.cy + this.height),
                right: parseFloat(this.cx + this.width),
                width: parseFloat(this.width),
                height: parseFloat(this.height)
            }

            if (this.render.rend) {
                this.render.rend(canvas, rect, this);
            }
        }
    }
    /*
        功能:更新缓存
        参数:无
        返回值:无
    */
    updataCache() {

    }
    /**
     *
     */
    formatRect() {
        this.cx = parseFloat(this.x + (this.borderWidth) / 2);
        this.cy = parseFloat(this.y + (this.borderWidth) / 2);
    }
    /*
        功能:初始化信息
        参数:无
        返回值:无
    */
    init() {
        this.formatRect();
    }

    /*
        功能:全屏（未发现调用，是否已经废弃？）
        参数:无
        返回值:无
    */
    fullScreenZoom(subScale) {
        if (subScale && (this.isZoom == undefined || this.isZoom == false)) {
            this.x = this.x * subScale.x;
            this.y = this.y * subScale.y;
            this.width = this.width * subScale.x;
            this.height = this.height * subScale.y;
            this.isZoom = true;
        }
    }
    /*
        功能:周期执行函数，由窗口根据数据刷新周期调用
        参数:无
        返回值:无
    */
    onTimer() {
        if (this.disableFlag) {
            return;
        }
        // 当前图元禁止隐藏,脚本执行
        if (!this.fvScriptHide) {
            // for (const property in this.animation) {
            // if(new Vue.prototype[property](this).type=="fvTwinkel"){
            //     for(var p in this.preAnimation){
            //         this.preAnimation[p].run(this.canvas,this.isEnable);
            //     }
            // }else{
            return;
            // }
            // }

        }
        if (this.canvas) {
            for (var p in this.preAnimation) {
                this.preAnimation[p].run(this.canvas, this.isEnable);
            }
        }

    }
    /*
        功能:执行动画
        参数:无
        返回值:无
    */
    runAnimation(event, domObj, mouseAnimType, show) {
        if (!this.isEnable) {
            //禁用时不响应事件
            return;
        }
        //要处理禁止动作//
        if (mouseAnimType == "fvForbid") {
            this.mouseAnimationList[fvForbid].run(event);
        }
        if (this.mouseAnimationList[mouseAnimType]) {
            this.mouseAnimationList[mouseAnimType].run(event,show, domObj);
        }
        // if(this.animation.fvMessage){
        //    // this.animation.fvMessage.run(event,canvas);
        // }
    }

    /*
        功能:鼠标按下
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseDownSvg(e, domObj) {
        this.isMouseMove = true;
        if (e.touches) {
            this.runAnimation(e, domObj.ctx, "fvLmousescript");
            this.runAnimation(e, domObj, "fvVarInput");
            this.runAnimation(e, domObj, "fvBoolInput");
            this.runAnimation(e, tdomObj, "fvStringInput");
            // this.runAnimation(e, domObj, "fvVerticalDrag");
            // this.runAnimation(e, tdomObj, "fvHorDrag");
            this.runAnimation(e, tdomObj, "fvWindowOpen");
        } else {
            switch (e.button) {
                case 0://鼠标左键按下
                    this.runAnimation(e, domObj, "fvLmousescript");
                    this.runAnimation(e, domObj, "fvVarInput");
                    this.runAnimation(e, domObj, "fvBoolInput");
                    this.runAnimation(e, domObj, "fvStringInput");
                    // this.runAnimation(e, domObj,"fvVerticalDrag");
                    // this.runAnimation(e, domObj, "fvHorDrag");
                    this.runAnimation(e, domObj, "fvWindowOpen");
                    //用于动画与点击同步执行
                    setTimeout(() => {
                        for (var p in this.preAnimationList) {
                            //判断是否是 流动
                            if (p != "fvFlow") {
                                this.preAnimationList[p].run(domObj);
                            }
                        }
                    }, 300);
                    break;
                case 1:
                    //this.runAnimation(e,this.parent.ctx,MOUSEANIMTYPE_RMOUSE);
                    break;
                case 2:
                    this.runAnimation(e, domObj, "fvRmousescript");
                    this.runAnimation(e, domObj, "fvContextMenu");
                    break;
                default:
                    break;
            }
        }
    }

    /*
        功能:鼠标弹起
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseUpSvg(e) {
        this.isMouseMove = false;
        if (e.touches) {
            this.runAnimation(e, this.parent.ctx, "fvLmousescript", 0);
            //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
        } else {
            switch (e.button) {
                case 0://鼠标左键抬起
                    this.runAnimation(e, this.parent.ctx, "fvLmousescript");
                    //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                    break;
                case 1:
                    break;
                case 2:
                    this.runAnimation(e, this.parent.ctx, "fvRmousescript");
                    break;
                default:
                    break;
            }
        }

        // //鼠标在图元外抬起时
        // this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
        // this.runAnimation(e,this.parent.ctx,"fvHorDrag");
    }
    /*
        功能:鼠标移动
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseMoveSvg(e, domObj) {
        if (this.isMouseMove == true) {
            //拖动动画
            this.runAnimation(e, domObj, "fvVerticalDrag");//垂直
            this.runAnimation(e, domObj, "fvHorDrag");//水平
        }
        this.runAnimation(e, domObj, "fvMessage", true);
        this.runAnimation(e, domObj, "fvMousescript","移动");
    }
    /*
        功能:鼠标进入
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseEnterSvg(e) {
        //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
        //this.runAnimation(e,this.parent.ctx,"fvHorDrag");
        this.runAnimation(e, this.parent.ctx, "fvMessage", true);
        this.runAnimation(e, this.parent.ctx, "fvMousescript","进入");
    }
    /*
        功能:鼠标离开
        参数:e 属性信息 scaleObj 缩放信息
        返回值:无
    */
    onMouseLeaveSvg(e) {
        this.isMouseMove = false;
        this.runAnimation(e, this.parent.ctx, "fvMessage", false);
        this.runAnimation(e, this.parent.ctx, "fvMousescript","离开");
    }

    /*
        功能:鼠标位置判断
        参数:event 属性信息 scaleObj 缩放信息
        返回值:是否命中图元
    */
    doFixedEvent(event, scaleObj, doFixEventOnMouseUp) {
        if (doFixEventOnMouseUp == undefined) {
            var doFixEventOnMouseUp = {
                top: 0,
                left: 0
            }
        }
        if (!this.isEnable) {
            //禁用时不响应事件
            return null;
        }
        if (this.canvas) {
            var eventX = event.clientX + this.canvas.canvas.parentNode.parentNode.parentNode.scrollLeft;
            var eventY = event.clientY + this.canvas.canvas.parentNode.parentNode.parentNode.scrollTop;
        } else {
            var eventX = this.mouseX(event);
            var eventY = this.mouseY(event);
        }
        //判断是否使用app打开pc窗口
        if (scaleObj.isApp == true && scaleObj.winType == "pc") {
            if (scaleObj.turn == "portrait") {
                var leftX = parseInt(scaleObj.ox + (this.originalSize.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.x - scaleObj.scrollWidth) - doFixEventOnMouseUp.left;
                var rightX = parseInt((this.originalSize.width * (scaleObj.sx + scaleObj.zoom)) + leftX) - doFixEventOnMouseUp.left;
                var topY = parseInt(scaleObj.oy + (this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y) + scaleObj.titleHeight - scaleObj.scrollHeight - doFixEventOnMouseUp.top;
                var bottomY = parseInt((this.originalSize.height * (scaleObj.sy + scaleObj.zoom)) + topY) - doFixEventOnMouseUp.top;
                if (eventX < rightX &&
                    eventX > leftX &&
                    eventY < bottomY &&
                    eventY > topY) {
                    return true;
                } else {
                    return false;
                }
            } else if(scaleObj.turn == "portraits"){
                var leftX = parseInt(scaleObj.ox + (this.originalSize.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.x - scaleObj.scrollWidth) - doFixEventOnMouseUp.left;
                var rightX = parseInt((this.originalSize.width * (scaleObj.sx + scaleObj.zoom)) + leftX) - doFixEventOnMouseUp.left;
                var topY = parseInt(scaleObj.oy + (this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y) + scaleObj.titleHeight - scaleObj.scrollHeight - doFixEventOnMouseUp.top;
                
                var bottomY = parseInt((this.originalSize.height * (scaleObj.sy + scaleObj.zoom)) + topY) - doFixEventOnMouseUp.top;
                if (eventX < rightX &&
                    eventX > leftX &&
                    eventY < bottomY &&
                    eventY > topY) {
                    return true;
                } else {
                    return false;
                }
            }else {
                if (scaleObj.embedView == 1) {

                    var leftX = this.cx + scaleObj.x;
                    var rightX = leftX + this.width;
                    var topY = this.cy + scaleObj.y + scaleObj.titleHeight;
                    var bottomY = this.height + topY;
                    if (eventX < rightX &&
                        eventX > leftX &&
                        eventY < bottomY &&
                        eventY > topY) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    var left = parseInt(scaleObj.ox + (this.originalSize.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.x - scaleObj.scrollWidth) - doFixEventOnMouseUp.left;
                    var right = parseInt((this.originalSize.width * (scaleObj.sx + scaleObj.zoom)) + left) - doFixEventOnMouseUp.left;
                    var top = parseInt(scaleObj.oy + (this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y) + scaleObj.titleHeight - scaleObj.scrollHeight - doFixEventOnMouseUp.top;
                    var bottom = parseInt((this.originalSize.height * (scaleObj.sy + scaleObj.zoom)) + top) - doFixEventOnMouseUp.top;
                    //高度加30 是头部
                    if (eventY > left + 30 &&
                        eventY < right + 30 &&
                        eventX > window.innerWidth - bottom &&
                        eventX < window.innerWidth - top) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }

        } else if (scaleObj.winType != "pc") {
            //用于是否是app竖屏
            /**
             * 作用：用于app加载pc工程强制横屏 重新计算点击区域
             */
            var leftX = this.cx + scaleObj.x;
            var rightX = leftX + this.width;
            var topY = this.cy + scaleObj.y;
            var bottomY = this.height + topY;
            if (eventX < rightX &&
                eventX > leftX &&
                eventY < bottomY &&
                eventY > topY) {
                return true;
            } else {
                return false;
            }
        } else {
            // //因为垂直拖动动画this.cx,cy位置不对
            // var y = parseInt(this.y - (this.borderWidth)/2);
            // var x = parseInt(this.x - (this.borderWidth)/2);
            // var leftX = x + scaleObj.x;
            // var rightX = leftX + this.width;
            // var topY = y + scaleObj.y + scaleObj.titleHeight;
            // var bottomY = this.height + topY;
            // if (eventX < rightX &&
            //     eventX > leftX &&
            //     eventY < bottomY &&
            //     eventY > topY) {
            //         console.log(777)
            //     return true;
            // } else {
            //     return false;
            // }
            var leftX = this.cx + scaleObj.x;
            var rightX = leftX + this.width;
            var topY = this.cy + scaleObj.y + scaleObj.titleHeight;
            var bottomY = this.height + topY;
            if (eventX < rightX &&
                eventX > leftX &&
                eventY < bottomY &&
                eventY > topY) {
                return true;
            } else {
                return false;
            }
        }
    }
    /*
        功能:设置图元被选中
        参数:无
        返回值:无
    */
    select(flag) {
        this.selectState = flag;
    }
    /*
        功能:允许或禁止
        参数:state 允许或禁止 标记, isGroup是否打组
        返回值:无
    */
    Enable(state, isGroup) {
        //isEnable:false 禁止；true：不禁止
        this.isEnable = state ? true : false;
        if (isGroup) {
            // 打组disableFlag true 禁止
            this.disableFlag = state ? false : true;
        }
    }
    /*
        功能:显示或隐藏
        参数:flag 允许或禁止 标记
        返回值:无
    */
    Show(flag, animation) {
        //fcHide:false 隐藏；true：不隐藏
        // 动画控制
        this.fcHide = flag ? true : false;
        this.isShow(flag);
        if (animation == "animation") {
            //脚本控制
            this.fvScriptHide = flag ? true : false;
        }
    }
    /*
        功能:获取线的格式
        参数:flag 允许或禁止 标记
        返回值:无
    */
    lineStyle(type) {
        var size = "";
        switch (type) {
            case 0:
                size = [0, 0];
                break;
            case 1:
                size = [18, 8];
                break;
            case 2:
                size = [3.5, 3.5];
                break;
            case 3:
                size = [8, 3.5, 3.5];
                break;
            case 4:
                size = [3, 3, 6];
                break;
            default:
                size = [0, 0];
                break;
        }
        return size;
    }
    /*
        功能:鼠标坐标系转换
        参数:evt 鼠标信息
        返回值:无
    */
    mouseX(evt) {
        if (evt.pageX) return evt.pageX;
        else if (evt.clientX)
            return evt.clientX + (document.documentElement.scrollLeft ?
                document.documentElement.scrollLeft :
                document.body.scrollLeft);
        else return null;
    }
    /*
        功能:鼠标坐标系转换
        参数:evt 鼠标信息
        返回值:无
    */
    mouseY(evt) {
        if (evt.pageY) return evt.pageY;
        else if (evt.clientY)
            return evt.clientY + (document.documentElement.scrollTop ?
                document.documentElement.scrollTop :
                document.body.scrollTop);
        else return null;
    }
    /*
        功能:服务端实时数据返回通知接口
        参数:无
        返回值:无
    */
    onUpdata() {

    }
    /*
        功能:绘制
        参数:canvas 父对象的 canvas 对象
        返回值:无
    */

    onDraw(canvas, flag) {

    }
    /*
        功能:重绘
        参数:scaleObj 缩放信息(此参数仅对精灵组件生效)
        返回值:无
    */
    reDraw(scaleObj) {
        this.isUpdataCache = true;
        this.zoom();
        this.init();
        //缩放传参给fvText文本缩放信号，其他图元不需要处理
        //this.cache(this.parent.cacheCtx,"reDraw");
    }

    onClose() {

    }
}



// WEBPACK FOOTER //
// ./src/js/div/fvSubassembly.js